export enum MinimalScheduleType {
  TRENING = 'TRENING',
  FEE = 'FEE'
}

export const MinimalScheduleTypeTranslation = {
  [MinimalScheduleType.TRENING]: 'enum.minimalScheduleType.trening',
  [MinimalScheduleType.FEE]: 'enum.minimalScheduleType.fee'
};
